import { render } from "./KeywordsTable.vue?vue&type=template&id=14ada2c8&scoped=true"
import script from "./KeywordsTable.vue?vue&type=script&lang=js"
export * from "./KeywordsTable.vue?vue&type=script&lang=js"

import "./KeywordsTable.vue?vue&type=style&index=0&id=14ada2c8&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14ada2c8"]])

export default __exports__